/**
 * @file: 取消选择
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as SelectToolkit from './toolkit';
import * as CaptureRule from './captureRule';
import Message from './message';
import Store from './store/index';
import ShortCutKey from '../shortcutkey/index';
import { StageEvent } from '../../message/index';

// 鼠标按下时取消
function downCancel(ev: JQuery.MouseDownEvent): void {
    let $target: JQuery<EventTarget> = $(ev.target);
    let cubeId: CubeId = CaptureRule.queryCubeIdBeHit($target);
    let selectedCube: CubeNode|null = CubeTree.findByCubeId(cubeId);

    /**
     * 鼠标按中cube，并且此cube可以被选中，而且此cube之前没有被选中，如果按中的cube是已经
     * 被选中的，需要return，因为需要考虑拖拽多个被选中的cube
     */
    if (selectedCube
        && SelectToolkit.canSelect(selectedCube)
        && !Store.has(cubeId)) {
        SelectToolkit.clearAllSelect();
        Message.panelSelectAsync();
        return;
    }

    // 鼠标并没有按中cube，或者被按中的cube不能被选中
    if (!selectedCube || !SelectToolkit.canSelect(selectedCube)) {
        SelectToolkit.clearAllSelect();
        Message.panelSelectAsync();
    }
}

// 鼠标抬起取消
function upCancel(ev: JQuery.MouseUpEvent): void {
    let $target: JQuery<EventTarget> = $(ev.target);
    let cubeId: CubeId = CaptureRule.queryCubeIdBeHit($target);
    let selectedCube: CubeNode|null = CubeTree.findByCubeId(cubeId);

    /**
     * 解决多个选中cube时，按中其中1个cube，但没有拖拽，直接抬起鼠标
     * 此时需要取消除按中cube外的其他被选中的cube
     */
    if (selectedCube
        && SelectToolkit.canSelect(selectedCube)
        && Store.has(cubeId)) {
        let allSelectedCubes: CubeId[] = Store.getAll();
        let list: Set<CubeId> = new Set(allSelectedCubes);

        list.delete(cubeId);
        SelectToolkit.removeGroup(Array.from(list));
        Message.panelSelectAsync();
    }
}

export {
    downCancel,
    upCancel
}
